<template>
  <app-modal
    :modal-id="modalId"
    modal-alignment="top"
    @close-modal="closeModal"
  >
    <template slot="header">
      <h5 class="modal-title">{{ modalTitle }}</h5>
      <button
        type="button"
        class="close outline-none"
        data-dismiss="modal"
        aria-label="Close"
        @click.prevent="closeModal"
      >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>

    <template slot="body">
      <div class="mb-3">
        <h5 class="mb-2">{{ detail.title || "---" }}</h5>
        <div v-if="detail.type === 'employee_certification'" class="mb-2">
          <span class="badge badge-pill badge-success mr-2" v-if="detail.pricing_type !== 'credit_based'">Free</span>
          <span class="badge badge-pill badge-warning" v-else>{{ detail.credit_usage || 0 }} Credits Required</span>
        </div>
      </div>
      <div class="certificate-description-content" v-html="detail.description || '---'"></div>
    </template>

    <template slot="footer">
      <button
        type="button"
        class="btn btn-secondary"
        data-dismiss="modal"
        @click.prevent="closeModal"
      >
        {{ $t("close") }}
      </button>
    </template>
  </app-modal>
</template>

<script>
import { ModalMixin } from "../../../../../Mixins/ModalMixin";

export default {
  name: "CertificateDescriptionModal",
  mixins: [ModalMixin],
  props: {
    detail: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      modalId: "certificate-description-modal",
      modalTitle: this.$t("description"),
    };
  },
};
</script>

<style scoped>
.certificate-description-content {
  max-height: 60vh;
  overflow-y: auto;
  word-break: break-word;
}
</style>
